import './App.scss';
import Clock from './components/Clock';

function App() {

  return (
    <>
      <Clock />
    </>
  );
}

export default App;
